<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Pasaport Numarası</label>
            <v-validator :errors="errors" parameter="PassportNumber" :watch="value.PassportNumber">
                <input type="text" class="form-control" v-model="value.PassportNumber" placeholder="Pasaport Numarası"/>
            </v-validator>
        </div>  
        <div class="col-12 mb-1">
            <label class="form-label">Pasaport Tipi</label>
            <v-validator :errors="errors" parameter="Type" :watch="type">
                <v-select-list v-model="type" placeholder="Pasaport Tipi" label="name" :options="types"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Bitiş Tarihi</label>
            <v-validator :errors="errors" parameter="EndDate" :watch="value.EndDate">
                <v-date-picker v-model="value.EndDate" placeholder="Bitiş Tarihi"/> 
            </v-validator>
        </div> 
        <div class="col-12 mt-1">
            <b-form-checkbox v-model="value.IsActive">Aktif</b-form-checkbox>
        </div> 
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            types:[
                {value:'0',name:'Bordo Pasaport (Umumi Pasaport)'},
                {value:'1',name:'Yeşil Pasaport (Hususi Pasaport)'},
                {value:'2',name:'Gri Pasaport (Hizmet Pasaportu)'},
                {value:'3',name:'Siyah Pasaport (Diplomatik Pasaport)'}
            ]
        }
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.value==this.value.Type)
            },
            set:function(value){
                this.value.Type = value?.value || null
                this.value.PassportTypeName = value?.name || null
            }
        }
    }
}
</script>